import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'collapsableChoiceSetsEnabled',
  initialState: false,
  reducers: {
    setCollapsableChoiceSetsEnabled(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setCollapsableChoiceSetsEnabled } = slice.actions;

export default slice.reducer;
